<template>
  <div class="centerdiv">
    <h2>上传到rank目录下</h2>
    <el-row>
        <el-col :span="3" class='labright'>文件名</el-col>
        <el-col :span="21" class='textleft'>
          <el-input v-model="picName"></el-input>
        </el-col>
    </el-row>
    <el-row>
        <el-col :span="24" >
          <input  type="file" ref="file" @change="onChange" accept="image/*" />
        </el-col>
    </el-row>
    <el-row>
      <el-col :span="24" >
        <el-button type="primary" @click="submitUpload" style="width:150px">上传</el-button>
      </el-col>
    </el-row>
    <el-row>
      <div id="app-4">
        <ol>
          <li v-for="fn in imgFileList">
            {{ fn.url }}
          </li>
        </ol>
      </div>
    </el-row>
    <br>
    <br/>
    <h2>上传到fhProblem目录下,宽为868px，高不限</h2>
    <el-row>
        <el-col :span="24" >
          <input  type="file" ref="file" @change="onChange2" accept="image/*" />
        </el-col>
    </el-row>
    <el-row>
      <el-col :span="24" >
        <el-button type="primary" @click="submitUpload2" style="width:150px">上传</el-button>
      </el-col>
    </el-row>
    <el-row>
      <div id="app-4">
        <ol>
          <li v-for="fn in imgFileList2">
            {{ fn.url }}
          </li>
        </ol>
      </div>
    </el-row>
    
    <h2>上传到knowledgeImg目录下</h2>
    <el-row>
        <el-col :span="24" >
          <input  type="file" ref="file" @change="onChange3" accept="image/*" />
        </el-col>
    </el-row>
    <el-row>
      <el-col :span="24" >
        <el-button type="primary" @click="submitUpload3" style="width:150px">上传</el-button>
      </el-col>
    </el-row>
    <el-row>
      <div id="app-4">
        <ol>
          <li v-for="fn in imgFileList3">
            {{ fn.url }}
          </li>
        </ol>
      </div>
    </el-row>
    
    <el-row>
        <!--<img src='../assets/imgs/23k.jpg'/>-->
    </el-row>
    <el-row>
        <!--<img src='../assets/imgs/23k.png'/>-->
    </el-row>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { getUUID } from '@/utils/index.js'
  export default {
    data () {
      return {
        imgFileList: [],
        imgFileList2: [],
        imgFileList3: [],
        rankimgFile: null,
        knowledgeimgFile: null,
        fhProbleimgFile: null,
        startMain: 0,
        picName: ''
      }
    },
    computed: {
      ...mapGetters([
        'welcome'
      ])
    },
    created () {

    },
    mounted () {

    },
    methods: {
      showMsg (msg, type = 'warning') {
        this.$notify({
          title: '上传资源',
          message: msg,
          type: type
        })
      },
      commit () {

      },
      submitUpload () {
        if (window.FormData) {
          var objectkey = 'ranks/' + this.picName + '.jpg'
          console.log(objectkey)
          // var co = require('co')
          var OSS = require('ali-oss')
          var client = new OSS.Wrapper({
            region: 'oss-cn-shanghai',
            accessKeyId: 'LTAIUbDiVeNi1iCH',
            accessKeySecret: 'lvtggZAvoZ5mthqkgBD89qnmB892Jq',
            bucket: 'longmathimg'
          })
          console.log(this.rankimgFile)
          client.put(objectkey, Buffer.from(this.rankimgFile)).then(r2 => {
            this.imgFileList.push(r2)
            console.log('get success: ', r2)
          }).catch(err => {
            console.log(err)
          })
        }
      },
      submitUpload2 () {
        if (window.FormData) {
          var objectkey = 'fhProblem/' + getUUID() + '.jpg'
          console.log(objectkey)
          // var co = require('co')
          var OSS = require('ali-oss')
          var client = new OSS.Wrapper({
            region: 'oss-cn-shanghai',
            accessKeyId: 'LTAIUbDiVeNi1iCH',
            accessKeySecret: 'lvtggZAvoZ5mthqkgBD89qnmB892Jq',
            bucket: 'longmathimg'
          })
          console.log(this.fhProbleimgFile)
          client.put(objectkey, Buffer.from(this.fhProbleimgFile)).then(r2 => {
            this.imgFileList2.push(r2)
            console.log('get success: ', r2)
          }).catch(err => {
            console.log(err)
          })
        }
      },
      submitUpload3 () {
        if (window.FormData) {
          var objectkey = 'knowledgeImg/' + getUUID() + '.jpg'
          console.log(objectkey)
          // var co = require('co')
          var OSS = require('ali-oss')
          var client = new OSS.Wrapper({
            region: 'oss-cn-shanghai',
            accessKeyId: 'LTAIUbDiVeNi1iCH',
            accessKeySecret: 'lvtggZAvoZ5mthqkgBD89qnmB892Jq',
            bucket: 'longmathimg'
          })
          console.log(this.knowledgeimgFile)
          client.put(objectkey, Buffer.from(this.knowledgeimgFile)).then(r2 => {
            this.imgFileList3.push(r2)
            console.log('get success: ', r2)
          }).catch(err => {
            console.log(err)
          })
        }
      },
      onChange (event) {
        var file = event.target.files[0]
        /* if (!/image\/\w+/.test(file)) {
          console.log('图片格式不正确')
          return false
        } */
        var reader = new FileReader()
        let self = this
        reader.onload = function (event) {
          // 文件里的文本会在这里被打印出来
          self.rankimgFile = event.target.result
          console.log(self.rankimgFile)
        }
        reader.readAsArrayBuffer(file)
      },
      onChange2 (event) {
        var file = event.target.files[0]
        /* if (!/image\/\w+/.test(file)) {
          console.log('图片格式不正确')
          return false
        } */
        var reader = new FileReader()
        let self = this
        reader.onload = function (event) {
          // 文件里的文本会在这里被打印出来
          self.fhProbleimgFile = event.target.result
          console.log(self.fhProbleimgFile)
        }
        reader.readAsArrayBuffer(file)
      },
      onChange3 (event) {
        var file = event.target.files[0]
        /* if (!/image\/\w+/.test(file)) {
          console.log('图片格式不正确')
          return false
        } */
        var reader = new FileReader()
        let self = this
        reader.onload = function (event) {
          // 文件里的文本会在这里被打印出来
          self.knowledgeimgFile = event.target.result
          console.log(self.knowledgeimgFile)
        }
        reader.readAsArrayBuffer(file)
      }
    }
  }
</script>

<style scoped>
  .centerdiv {
    height: auto;
    text-align: center;
  }

  .labright {
    height: 50px;
    line-height: 40px;
    text-align: right;
    vertical-align: middle;
  }
  .labmiddle {
    height: 50px;
    line-height: 40px;
    text-align: center;
    vertical-align: middle;
  }
  .rowheight{
    text-align: right;
    vertical-align: middle;
  }
  .textleft {
    text-align: left;
    height: 30px;
  }

  .lableft {
    text-align: left;
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #20a0ff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// upload2Oss.vue?12fb9f6a